import React from 'react';
import { isFormEditable } from './dataHelpers';
import { DynamicUiContext, DynamicUiContextType } from './DynamicUiContext';
import { UiSection } from './types';

export function DynamicUiProvider({
  children,
  form,
  uiData,
  currentSection,
  isDeletable,
  isCreateMode,
  isEditing,
  setIsEditing,
  onDelete,
  clientId,
}: DynamicUiContextType & {
  children: React.ReactNode;
  currentSection: UiSection;
}) {
  const value = {
    form,
    uiData,
    isEditing,
    isDeletable,
    setIsEditing,
    isCreateMode,
    onDelete,
    clientId,
    toggleEditing: () => {
      if (isEditing) {
        form.reset();
      }
      setIsEditing(!isEditing);
    },
    items: [currentSection],
    isEditable: currentSection != null && isFormEditable(form, currentSection, uiData),
  };

  return <DynamicUiContext.Provider value={value}>{children}</DynamicUiContext.Provider>;
}
